import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Shield, MapPin } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_3885f60a-e4ce-4e7e-b71d-89edd5337d92/artifacts/2dlizjmm_Gemini_Generated_Image_1lmywa1lmywa1lmy.jpeg';

const FooterSection = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-slate-900 text-slate-300 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src={LOGO_URL}
                alt="ProposAI logo — plateforme d'appel d'offres IA au Canada"
                className="w-8 h-8 rounded-md object-contain bg-white p-0.5"
              />
              <span className="text-xl font-bold text-white">ProposAI</span>
            </div>
            <p className="text-sm text-slate-400 mb-3">
              {t('landing.footer.tagline')}
            </p>
            <div className="flex items-center gap-1.5 text-xs text-slate-500 mb-4">
              <MapPin className="w-3 h-3" />
              <span>Made in Canada — For Canadian Businesses</span>
            </div>
            {/* Trust badge */}
            <Link
              to="/trust"
              className="inline-flex items-center gap-1.5 bg-green-900/40 border border-green-700/50 text-green-400 text-xs px-3 py-1.5 rounded-full hover:bg-green-900/60 transition-colors"
            >
              <Shield className="w-3 h-3" />
              PIPEDA Compliant · Secure
            </Link>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('landing.footer.product')}</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#features" className="hover:text-white transition-colors">{t('landing.nav.features')}</a></li>
              <li><a href="/#pricing" className="hover:text-white transition-colors">{t('landing.nav.pricing')}</a></li>
              <li><a href="/#how-it-works" className="hover:text-white transition-colors">{t('landing.nav.howItWorks')}</a></li>
              <li><a href="/#best-practices" className="hover:text-white transition-colors">{t('landing.bestPractices.badge')}</a></li>
              <li><Link to="/alternatives" className="hover:text-white transition-colors text-primary font-medium">Compare vs Bonfire / Loopio</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/resources" className="hover:text-white transition-colors">Procurement Guides</Link></li>
              <li><Link to="/resources#articles" className="hover:text-white transition-colors">RFP Best Practices</Link></li>
              <li><Link to="/resources#articles" className="hover:text-white transition-colors">Vendor Management</Link></li>
            </ul>
          </div>

          {/* Trust & Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Trust & Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/trust" className="hover:text-white transition-colors flex items-center gap-1.5">
                  <Shield className="w-3 h-3 text-green-400" />
                  Trust Center
                </Link>
              </li>
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">{t('landing.footer.privacy')}</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">{t('landing.footer.terms')}</Link></li>
              <li><a href="mailto:info@proposai.ca" className="hover:text-white transition-colors">{t('landing.footer.contact')}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-400">{t('landing.footer.copyright')}</p>
            <div className="flex items-center gap-4 text-xs text-slate-500">
              <span>Built on Emergent.sh Infrastructure</span>
              <span className="text-slate-700">·</span>
              <span>99.9% Uptime SLA</span>
              <span className="text-slate-700">·</span>
              <span>SOC 2 Ready</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
